import ObjectiveSpokenResultView from "./share/ObjectiveSpokenResultView";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.homework.resultviews.poka1resultview;

class POKA1ResultView extends ObjectiveSpokenResultView {
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            preResult: props.result,
            ...POKA1ResultView.getInitState(props),
        };
    }

    static getDerivedStateFromProps(props, state) {
        if (props.result !== state.preResult) {
            return {
                ...state,
                preResult: props.result,
                ...POKA1ResultView.getInitState(props),
            };
        }
        return null;
    }

    static getInitState(props) {
        let { dialogs = [], practiceRole = 1 } = props.data || {};
        dialogs = _.flatMap(dialogs, d => d.sentences.map(sentence => ({ role: d.role, sentence })));
        return this.getDialogState(props, dialogs, practiceRole, _.cloneDeep(props.result));
    }
}

export default withTranslation(uid)(POKA1ResultView);
